/**
 * Custom syncer keys — second-level discriminator for CrmType.CUSTOM.
 *
 * Every private / partner-specific CRM integration registers a key here.
 * The Prisma enum stays at CUSTOM; this string identifies which implementation
 * to dispatch to from the registry.
 */
export const CUSTOM_SYNCER_KEYS = ["awko", "sokolove_domo", "weitz_domo"] as const;

export type CustomSyncerKey = (typeof CUSTOM_SYNCER_KEYS)[number];

export function isCustomSyncerKey(value: unknown): value is CustomSyncerKey {
  return typeof value === "string" && (CUSTOM_SYNCER_KEYS as readonly string[]).includes(value);
}

/**
 * Human-readable labels for custom syncers — shown to superadmins in the picker.
 * Not shown to end users unless their org is in allowedCustomSyncers.
 */
export const CUSTOM_SYNCER_LABELS: Record<CustomSyncerKey, string> = {
  awko: "AWKO",
  sokolove_domo: "Sokolove (Domo)",
  weitz_domo: "Weitz & Luxenberg (Domo)",
};

/** Syncers backed by the shared Domo transport (lib/crm/custom/domo). */
export const DOMO_SYNCER_KEYS = [
  "sokolove_domo",
  "weitz_domo",
] as const satisfies readonly CustomSyncerKey[];

export function isDomoSyncerKey(value: unknown): value is (typeof DOMO_SYNCER_KEYS)[number] {
  return typeof value === "string" && (DOMO_SYNCER_KEYS as readonly string[]).includes(value);
}
